export const getAnswer = q => {
  return q === true ? "YES" : q === false ? "NO" : null;
};
